import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import Ink from "react-ink";
import base64 from "base-64";
import api from "../../config/api";
import { BlobProvider } from "@react-pdf/renderer";
import { withRouter } from "react-router";
import moment from "moment";

import {
  isNetworkRequestFailedError,
  removeNewLineOrTab,
} from "../../config/helpers";
import PreviewModal from "./FormSummary/PreviewModal";
import constants from "../../config/constants";
import ConsentFormModal from "../../component/ConsentFormModal";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import ConsentFormPDF from "../../component/ConsentFormPDF";
import { imageToDataURL } from "../../config/helpers";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import rsaAction from "../../redux/rsaNINImplementation/action";
import InputComp from "../../component/InputComp/InputComp";
import CustomButton from "../../component/CustomButton/CustomButton";

class Picture extends Component {
  state = {
    pictureImageError: "",
    isLoading: false,
    pathname: "",
    isConsentAccepted: false,
    showPreview: false,
  };

  componentDidMount() {
    const { customRef, history, setHistory } = this.props;

    this.setState({
      pathname: history.location.pathname,
    });

    customRef({ validate: this.validate });
    setHistory(history);
  }

  handleOnChange = async (e) => {
    const { setPictureField, setAlertMessage } = this.props;

    try {
      if (e.target.files[0]) {
        const response = await imageToDataURL(e.target.files[0]);

        setPictureField(response);
        this.openModal();
      }
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.handleOnChange(e)
          : null,
      });
    }
  };

  openModal = () => {
    this.props.setConsentFormField("");
    this.setState({ isModal: true });
  };

  validate = () => {
    const { pictureImage, formImage } = this.props;
    let error = "";

    if (!pictureImage) {
      error = "Picture is required";
    } else if (!formImage) {
      error = "Please accept consent form";
    }

    return error;
  };

  upload = async () => {
    const {
      personalDetail,
      employer,
      nextOfKin,
      residence,
      pictureImage,
      formImage,
      signatureImage,
      bankDetails,
      validateUser,
      setAlertMessage,
      resetRSAForm,
    } = this.props;

    const header = {
      Authorization:
        "Basic " +
        base64.encode(validateUser.userName + ":" + validateUser.password),
    };

    try {
      if (this.validate()) {
        throw new Error(this.validate());
      }

      this.setState({ isLoading: true });

      const data = {
        ...personalDetail,
        ...employer,
        ...nextOfKin,
        ...residence,
        ...bankDetails,
        pictureImage: pictureImage ? pictureImage.split("base64,")[1] : "",
        formImage: formImage ? formImage.split("base64,")[1] : "",
        signatureImage: signatureImage
          ? signatureImage.split("base64,")[1]
          : "",
        agentCode: "MPPPPL",
      };
      data.employerRcno = employer.employerRawCode;
      delete data.employerRawCode;
      delete data.employerCode;
      delete data.confirmMobilePhone;
      delete data.confirmEmail;
      delete data.confirmEmployerPhone;
      delete data.nokConfirmEmailaddress;
      delete data.nokConfirmMobilePhone;
      // console.log("data =>", data);

      // delete data.firstName;
      delete data.middleName;
      // delete data.maidenOrFormerName;
      // delete data.employerStateCode
      // delete data.dateOfFirstAppointment
      delete data.nokMiddleName;
      delete data.nokResidenceStateCode;

      // delete data.picture
      // delete data.consentForm
      // delete data.signature

      delete data.residenceHouseNo;
      delete data.employerStreetName;
      delete data.employerBuildingNameOrNumber;
      delete data.nokResidenceHouseNumber;

      // delete data.ninVerificationToken;
      // delete data.baseURL;
      // delete data.isFormHidden;

      let response = null;

      const email = data.email || constants.NOTIFICATION_API_DEFAULT_EMAIL;

      if (!data.email) {
        delete data.email;
      }

      response = await api.publicRSAPinSubmit(data, header);
      // response = await api.RSAPinSubmit(data, header);

      setAlertMessage({ type: "success", message: response.errorMessage });

      const emailConfirmationData = {
        userEmail: email,
        firstName: data.firstname,
        nin: data.ssn,
        phone: data.mobilePhone,
      };

      await api.sendRegisterationNotification(emailConfirmationData, null);

      resetRSAForm();
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.upload : null,
      });
    }

    this.setState({ isLoading: false });
  };

  getName = () => {
    const { personalDetail } = this.props;

    return {
      firstName: personalDetail.firstname || "",
      middleName: personalDetail.middleName || "",
      lastName: personalDetail.surname || "",
    };
  };

  handleSubmit = () => {
    this.setState({ submit: true, isConsentAccepted: true });
  };

  getDataForPDF = () => {
    const { personalDetail, signatureImage } = this.props;

    return {
      name: {
        firstName: personalDetail.firstname,
        middleName: personalDetail.middleName,
        lastName: personalDetail.surname,
      },
      signature: signatureImage,
    };
  };

  getPreviewData = () => {
    return [
      {
        label: "Form Reference Number",
        value: this.props.personalDetail.formRefno,
      },
      {
        label: "Surname",
        value: this.props.personalDetail.surname,
      },
      {
        label: "First Name",
        value: this.props.personalDetail.firstname,
      },
      {
        label: "Middle Name",
        value: this.props.personalDetail.middleName,
      },
      {
        label: "Other Names",
        value: this.props.personalDetail.othernames,
      },
      {
        label: "Nationality",
        value: this.props.personalDetail.nationalityCode,
      },
      {
        label: "State of Origin",
        value: this.props.personalDetail.stateOfOrigin,
      },
      {
        label: "LGA Code",
        value: this.props.personalDetail.lgaCode,
      },
      {
        label: "Title",
        value: this.props.personalDetail.title,
      },
      {
        label: "Gender",
        value: this.props.personalDetail.gender,
      },
      {
        label: "Marital status",
        value: this.props.personalDetail.maritalStatusCode,
      },
      {
        label: "Date of Birth",
        value: this.props.personalDetail.dateOfBirth
          ? moment(this.props.personalDetail.dateOfBirth).format("MM/DD/YYYY")
          : "",
      },
      {
        label: "Place of Birth",
        value: this.props.personalDetail.placeOfBirth,
      },
      {
        label: "Permanent Country",
        value: this.props.personalDetail.permCountry,
      },
      {
        label: "Permanent City",
        value: this.props.personalDetail.permCity,
      },
      {
        label: "Maiden/Former Name",
        value: this.props.personalDetail.maidenName,
      },
      {
        label: "Permanent Address Location",
        value: this.props.personalDetail.permanentAddressLocation,
      },
      {
        label: "Permanent State",
        value: this.props.personalDetail.permState,
      },
      {
        label: "Permanent LGA",
        value: this.props.personalDetail.permLga,
      },
      {
        label: "Mobile Phone",
        value: this.props.personalDetail.mobilePhone,
      },

      {
        label: "National Identity Number (NIN)",
        value: this.props.personalDetail.ssn,
      },
      {
        label: "Bank Verification Number",
        value: this.props.personalDetail.bvn,
      },
      {
        label: "Permanent Address of Account Holder",
        value: this.props.residence.permanentAddress,
      },
      {
        label: "Other Address Details",
        value: this.props.residence.permanentAddress1,
      },
      {
        label: "Zip",
        value: this.props.residence.permZip,
      },
      {
        label: "Email",
        value: this.props.residence.email,
      },

      {
        label: "P. O. Box of Account Holder",
        value: this.props.residence.permBox,
      },
      {
        label: "Sector of Employment",
        value: this.props.employer.employerType,
      },
      {
        label: "Employer",
        value: removeNewLineOrTab(this.props.employer.employerCode),
      },
      {
        label: "Employer City",
        value: this.props.employer.employerCity,
      },
      {
        label: "Employer’s Country of Origin",
        value: this.props.employer.employerCountry,
      },
      {
        label: "Employer Location",
        value: this.props.employer.employerLocation,
      },
      {
        label: "Employer State Code",
        value: this.props.employer.employerStatecode,
      },
      {
        label: "State Of Posting",
        value: this.props.employer.stateOfPosting,
      },
      {
        label: "Employer LGA",
        value: this.props.employer.employerLga,
      },
      {
        label: "Employer’s Contact phone",
        value: this.props.employer.employerPhone,
      },

      {
        label: "Employer’s P.O. Box",
        value: this.props.employer.employerBox,
      },
      {
        label: "Employer Business",
        value: this.props.employer.employerBusiness,
      },
      {
        label: "Employer’s Main Address",
        value: this.props.employer.employerAddress1,
      },
      {
        label: "Employer’s Additional Address",
        value: this.props.employer.employerAddress,
      },
      {
        label: "Employer’s ZIP Code",
        value: this.props.employer.employerZip,
      },
      {
        label: "First Appointment Date",
        value: this.props.employer.dateOfFirstApointment
          ? moment(this.props.employer.dateOfFirstApointment).format(
              "MM/DD/YYYY"
            )
          : "",
      },
      {
        label: "NOK Title",
        value: this.props.nextOfKin.nokTitle,
      },
      {
        label: "NOK First Name",
        value: this.props.nextOfKin.nokName,
      },
      {
        label: "NOK Middle Name",
        value: this.props.nextOfKin.nokOthername,
      },
      {
        label: "NOK Surname",
        value: this.props.nextOfKin.nokSurname,
      },
      {
        label: "NOK Gender",
        value: this.props.nextOfKin.nokGender,
      },
      {
        label: "Next Of Kin Country",
        value: this.props.nextOfKin.nokCountry,
      },
      {
        label: "Next of Kin Mobile Phone",
        value: this.props.nextOfKin.nokMobilePhone,
      },

      {
        label: "NOK Relationship",
        value: this.props.nextOfKin.nokRelationship,
      },
      {
        label: "Next of Kin Email",
        value: this.props.nextOfKin.nokEmailaddress,
      },

      {
        label: "Next of Kin Location",
        value: this.props.nextOfKin.nokLocation,
      },
      {
        label: "Next of Kin Address",
        value: this.props.nextOfKin.nokAddress1,
      },
      {
        label: "Next of Kin Additional Address",
        value: this.props.nextOfKin.nokAddress,
      },
      {
        label: "NOK Residence House Number",
        value: this.props.nextOfKin.nokResidenceHouseNumber,
      },

      {
        label: "Next of Kin city",
        value: this.props.nextOfKin.nokCity,
      },
      {
        label: "NOK Residence State Code",
        value: this.props.nextOfKin.nokStatecode,
      },
      {
        label: "Next of Kin Local Govt",
        value: this.props.nextOfKin.nokLga,
      },
      {
        label: "Next of Kin P.O.Box",
        value: this.props.nextOfKin.nokBox,
      },
      {
        label: "Next of Zip",
        value: this.props.nextOfKin.nokZip,
      },

      {
        label: "Bank Name",
        value: this.props.bankDetails.bankName,
      },
      {
        label: "Bank Account Name",
        value: this.props.bankDetails.accountName,
      },

      {
        label: "Bank Account Number",
        value: this.props.bankDetails.accountNumber,
      },
    ];
  };

  render() {
    const { pictureImage } = this.props;
    const { pictureImageError, isLoading, isModal } = this.state;

    return (
      <div>
        <input
          onChange={this.handleOnChange}
          style={{ display: "none" }}
          type="file"
          id="pictureImage"
        />
        <Row className="flex1">
          <Col lg={9} md={9} sm={6} className="p-0">
            <InputComp
              disabled={true}
              errorMessage={pictureImageError}
              type="text"
              placeholder="Picture"
              containerStyles={{ width: "100%" }}
            />
          </Col>
          <Col lg={3} md={3} sm={6} className="mx-auto pl-0 pl-sm-3 pr-0">
            <label className="browser-btn-container" htmlFor="pictureImage">
              <span className="btn browse-btn">
                Browse
                <Ink />
              </span>
            </label>
          </Col>
        </Row>
        {!!pictureImage && (
          <div className="text-center my-2">
            <img alt="" width="300px" src={pictureImage} />
          </div>
        )}
        <div className="text-center my-2">
          <Row className="my-2 justify-content-center">
            {this.props.pictureImage && !this.state.isConsentAccepted && (
              <Col className="p-0 pr-2" sm={6} md={3}>
                <CustomButton
                  buttonClasses="btn-block"
                  buttonText="Accept Consent Form"
                  onClick={() => {
                    this.setState({ isModal: true });
                  }}
                />
              </Col>
            )}
            {this.state.isConsentAccepted && (
              <Col className="p-0 pr-2" sm={6} md={3}>
                <CustomButton
                  buttonClasses="btn-block"
                  buttonText="Preview and print"
                  onClick={() => {
                    this.setState({ showPreview: true });
                  }}
                />
              </Col>
            )}
            <Col className="p-0" sm={6} md={3}>
              <CustomButton
                buttonClasses="btn-block"
                buttonText="Upload"
                onClick={() => {
                  this.upload();
                }}
              />
            </Col>
          </Row>
        </div>
        {isLoading && <CustomLoader />}
        <ConsentFormModal
          signature={this.props.signatureImage}
          onSubmit={this.handleSubmit}
          name={this.getName()}
          onClose={() => this.setState({ isModal: false })}
          isOpen={isModal}
        />

        <PreviewModal
          data={this.getPreviewData()}
          picture={pictureImage}
          name={this.getName()}
          signature={this.props.signatureImage}
          onClose={() => this.setState({ showPreview: false })}
          isOpen={this.state.showPreview}
        />

        {this.state.submit && (
          <BlobProvider
            document={<ConsentFormPDF data={this.getDataForPDF()} />}
          >
            {({ blob, loading }) => {
              if (!loading && !this.state.blob) {
                const reader = new FileReader();

                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;

                  this.props.setConsentFormField(base64data);
                  this.setState({ submit: false });
                };

                this.setState({ blob });
              }

              return null;
            }}
          </BlobProvider>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  personalDetail: state.rsaNINImplementation.personalDetail,
  pictureImage: state.rsaNINImplementation.pictureImage,
  residence: state.rsaNINImplementation.residence,
  employer: state.rsaNINImplementation.employer,
  nextOfKin: state.rsaNINImplementation.nextOfKin,
  signatureImage: state.rsaNINImplementation.signatureImage,
  formImage: state.rsaNINImplementation.formImage,
  bankDetails: state.rsaNINImplementation.bankDetails,
  token: state.rsaNINImplementation.token,
  ninVerificationToken: state.rsaNINImplementation.ninVerificationToken,
  baseURL: state.rsaNINImplementation.baseURL,
  isFormHidden: state.rsaNINImplementation.isFormHidden,
  validateUser: state.onboarding.user,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setPictureField: rsaAction.setPictureField,
  setAlertMessage: authAction.setAlertMessage,
  setConsentFormField: rsaAction.setConsentFormField,
  resetRSAForm: rsaAction.resetRSAForm,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Picture));
